export interface DashboardWidgetDefinition {
  id: string;
  title: string;
  accessGroup?: 'CAPEX' | 'OPEX';
  featureFlag?: 'enableAssetAnalysisChart' | 'enableRecentlyAddedAssetsWidget';
  enabled?: boolean;
}

export interface DashboardLayoutWidget {
  id: string;
}

export interface DashboardLegacyRowWidget {
  type: string;
  title?: string;
  wid?: string;
  config?: Record<string, unknown>;
}

export interface DashboardLegacyColumn {
  styleClass?: string;
  cid?: string;
  widgets: DashboardLegacyRowWidget[];
}

export interface DashboardLegacyRow {
  columns: DashboardLegacyColumn[];
}

export interface DashboardLayoutModel {
  selectedWidgets: DashboardLayoutWidget[];
  rows?: DashboardLegacyRow[];
}

export interface DashboardAccess {
  hasCapex: boolean;
  hasOpex: boolean;
  hasCombinedFromRights: boolean;
}

export const DASHBOARD_WIDGET_TITLES: Record<string, string> = {
  'newSearch': 'New Search (Projects or Contract Awards)',
  'repeatLastSearch': 'Repeat Last Search',
  'savedSearches': 'Saved Project/Contract Award Searches',
  'recentlyAddedProjects': 'Recently Added Projects',
  'recentlyAwardedContracts': 'Recently Awarded Contracts',
  'quickFindProject': 'Quickly Locate a Project by Name or ID',
  'numberOfProjectsChart': 'Projects In EICDataStream',
  'asset-analysis-chart': 'Assets in EICAssetMap',
  'recently-added-assets': 'Recently Added Assets'
};

export const DASHBOARD_WIDGET_DEFINITIONS: DashboardWidgetDefinition[] = [
  { id: 'newSearch', title: DASHBOARD_WIDGET_TITLES['newSearch'], accessGroup: 'CAPEX' },
  { id: 'repeatLastSearch', title: DASHBOARD_WIDGET_TITLES['repeatLastSearch'], accessGroup: 'CAPEX' },
  { id: 'savedSearches', title: DASHBOARD_WIDGET_TITLES['savedSearches'], accessGroup: 'CAPEX' },
  { id: 'recentlyAddedProjects', title: DASHBOARD_WIDGET_TITLES['recentlyAddedProjects'], accessGroup: 'CAPEX' },
  { id: 'recentlyAwardedContracts', title: DASHBOARD_WIDGET_TITLES['recentlyAwardedContracts'], accessGroup: 'CAPEX' },
  { id: 'quickFindProject', title: DASHBOARD_WIDGET_TITLES['quickFindProject'], accessGroup: 'CAPEX' },
  { id: 'numberOfProjectsChart', title: DASHBOARD_WIDGET_TITLES['numberOfProjectsChart'], accessGroup: 'CAPEX' },
  { id: 'asset-analysis-chart', title: DASHBOARD_WIDGET_TITLES['asset-analysis-chart'], accessGroup: 'OPEX', featureFlag: 'enableAssetAnalysisChart' },
  { id: 'recently-added-assets', title: DASHBOARD_WIDGET_TITLES['recently-added-assets'], accessGroup: 'OPEX', featureFlag: 'enableRecentlyAddedAssetsWidget' }
];

export const DASHBOARD_DEFAULT_LAYOUT: DashboardLayoutModel = {
  selectedWidgets: [
    { id: 'newSearch' },
    { id: 'repeatLastSearch' },
    { id: 'savedSearches' },
    { id: 'recentlyAddedProjects' },
    { id: 'recentlyAwardedContracts' },
    { id: 'quickFindProject' },
    { id: 'numberOfProjectsChart' },
    { id: 'asset-analysis-chart' },
    { id: 'recently-added-assets' }
  ]
};
